import VGet from './v-get';
export default class VInvalid extends VGet {
  compute([obj, path]) {
    return super.compute([obj, path, 'isInvalid']);
  }
}